export type UpdatePasswordInputs = {
  oldPwd: string;
  newPwd: string;
  confirmaPwd: string;
};

export const dataPasswords: {
  id: keyof UpdatePasswordInputs;
  placeholder: string;
}[] = [
  { id: "oldPwd", placeholder: "Vieja contraseña" },
  { id: "newPwd", placeholder: "Nueva contraseña" },
  { id: "confirmaPwd", placeholder: "Confirmá tu nueva contraseña" },
];
